import React, { Suspense, useEffect, useState } from 'react';
import { useAllBook } from 'store/books/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { sortname } from "utils/methods/math";
// import { useServertime } from 'store/servertime/selectors';
import { useClassSubmissions } from 'store/submissions/selectors';
import { useUsersByClass } from "store/userClasses/selectors";
import { get, find, map, filter, groupBy, uniqBy, cloneDeep } from "lodash"
import { Drawer } from "antd"
import Loading from 'components/Loading';
import { useUserPreference } from "store/userPreference/selectors"
import AssignmentReview from 'features/forms/AssignmentReview';
import { useDispatch, useSelector } from 'react-redux';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { useCurrentOrg } from "store/organizations/selectors"
import {  Visibility  } from '@mui/icons-material';
import {IconButton} from '@mui/material'
import * as Sentry from '@sentry/react';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import SentryWrap from 'components/Sentry';
export default function AssignmentReviewByTeacher({ assignment, onReviewClick = () => null}) {
    const showAlert = useAlert()
    const classActivities = useClassActivities()
    const usersByClass = useUsersByClass()
    const classQuizzes = useClassQuizzes()
    const submissions = useClassSubmissions()
    const booksAllList = useAllBook()
    const dispatch = useDispatch();
    const currentClass = useCurrentClass()
    const userPreference = useUserPreference()
    const currentOrg = useCurrentOrg()
    const [selectedAssignmentUserSubmission, setSelectedAssignmentSubmissions] = useState([])
    const [assignmentData, setAssignmentData] = useState({});
    const filteredClassUsers = filter(usersByClass[get(currentClass, "id")], (user) => user?.role === 'student');
    const currentClassUsers = usersByClass ? filteredClassUsers : [];
    const studentSubmissions = groupBy(submissions, 'userId');
    const users = useSelector((state) => state.classUsers);
    const [listStudentUser,setListStudentUser] = useState(users && users.length > 0 ? filter(users, x => x.role === 'student' && x?.userclass?.active === true).sort(sortname) : new Array(1).fill({}, 0, 1))
    const firstStudentOfClass = currentClassUsers?currentClassUsers[0]:{}
    const [assignmentDrawer, toggleAssignmentDrawer] = useState(false);
    const fetchAllData = async () => {
        dispatch(handleListClassSubmissions(get(currentClass, "id")))
    }

    useEffect(() => {
        const allstudents = uniqBy(filter(users, x => x.role === 'student').sort(sortname), "username");
        const viewStudents = allstudents.filter(u => u?.userclass?.active === true);
        const finalList = viewStudents.length > 0 ? viewStudents : [];
        setListStudentUser(finalList);
    }, [users, sortname])

    const getAssignmentCreation = (assignmentdata, userdata) => {
        try {
            const is_game = assignmentdata && (assignmentdata.type === 'game' || assignmentdata.type === 'debate' || assignmentdata.type === 'bingo' ||   assignmentdata.type === 'worksheet');
            if(is_game) {
                let quizdata = {
                    answers: [],
                    assignment: assignmentdata.assignment,
                    assignmentId: assignmentdata.session_id,
                    assignmentType: assignmentdata.type,
                    chapter: assignmentdata.bookId,
                    classId: currentClass.id,
                    complete: false,
                    createdAt: Date.now(),
                    feedback: '',
                    grade: null,
                    graded: true,
                    isLate: false,
                    orgId: currentOrg?.id,
                    retakes: 0,
                    retaking: false,
                    submissions: 0,
                    face_grade: null,
                    timmer: 0,
                    user: userdata,
                    userId: userdata.id,
                    bookId: assignmentdata.bookId,
                    isTemp: true
                }
                return quizdata;
            }else{
                let _assignmentinfo = assignmentdata.data ?? {};
                let quizdata = {
                    answers: [],
                    assignment: _assignmentinfo,
                    assignmentId: _assignmentinfo.id,
                    assignmentType: _assignmentinfo.typeId,
                    chapter: _assignmentinfo.chapter,
                    classId: currentClass.id,
                    complete: false,
                    createdAt: Date.now(),
                    feedback: '',
                    grade: null,
                    face_grade: null,
                    graded: true,
                    isLate: false,
                    orgId: currentOrg?.id,
                    retakes: assignmentdata.retakes,
                    retaking: false,
                    submissions: 0,
                    timmer: 0,
                    user: userdata,
                    userId: userdata.id,
                    bookId: _assignmentinfo.bookId,
                    isTemp: true
                }
                return quizdata;
            }      
        } catch (error) {
            Sentry.captureException(`151 Error in getAssignmentCreation: ${error}`);
            return {};
        }
    }
    const reviewAssignment = (data, tempData, users, userSubmissions) => {
        const  _assignment = [...classActivities, ...classQuizzes].filter(a => (a.quizId === get(data, "assignmentId")) || a.activityId === get(data, "assignmentId"))[0];
        let sAssignmentId = get(data, "sAssignmentId");
        if (_assignment&&_assignment.sAssignmentId) {
            sAssignmentId = _assignment.sAssignmentId;
        }
        if (data) {
            data.sAssignmentId = sAssignmentId;
        }
        if (!data) {
            const utemp = cloneDeep(tempData);
            utemp.isTemp = true;
            data = utemp;
            data.sAssignmentId = sAssignmentId;
        }
        const userdata = map(users, usr => {
            const sub = userSubmissions[usr.id]
            if (sub) {
                const asub = find(sub, n => get(n, "assignmentId") == get(data, "assignmentId", get(tempData, "assignmentId")))
                if (asub) {
                    asub.sAssignmentId = sAssignmentId;
                    return asub
                } else {
                    const utemp = cloneDeep(tempData);
                    utemp.userId = usr.id;
                    utemp.user = usr;
                    utemp.isTemp = true;
                    utemp.sAssignmentId = sAssignmentId;
                    return utemp;
                }
            } else {
                const utemp = cloneDeep(tempData);
                utemp.userId = usr.id;
                utemp.user = usr;
                utemp.isTemp = true;
                utemp.sAssignmentId = sAssignmentId;
                return utemp;
            }
        })
        setSelectedAssignmentSubmissions(userdata)
        setAssignmentData(data);
        toggleAssignmentDrawer(true);
    };
   const onClick = ()=>{
    if(!listStudentUser||listStudentUser.length==0){
        showAlert(`No students are enrolled in this class!`, "error");
       return;
    }
    onReviewClick();
    const tempData = getAssignmentCreation(assignment,firstStudentOfClass);
    let v = tempData;
    if(firstStudentOfClass&&studentSubmissions[firstStudentOfClass.id]){
        const asub = find(studentSubmissions[firstStudentOfClass.id], n => get(n, "assignmentId") == get(assignment, "assignmentId", get(tempData, "assignmentId")))
        if(asub){
            v = asub;
        }
    }
    reviewAssignment(v,tempData,listStudentUser,studentSubmissions)
   }
   const onClose = () =>{
    toggleAssignmentDrawer(false)
   }
    return (<SentryWrap>
    <IconButton onClick={onClick}>
    <Visibility  />
    </IconButton>
        <Drawer
            height='100%'
            destroyOnHidden
            onClose={() => {
                toggleAssignmentDrawer(false);
                setAssignmentData({});
                setSelectedAssignmentSubmissions([])
            }}
            placement='top'
            open={assignmentDrawer}
            key='assignmentNew'
            className='student-review-new'
        >
            {assignmentDrawer ? (
                <Suspense fallback={<Loading />}>
                    <AssignmentReview
                        open={assignmentDrawer}
                        booksAllList={booksAllList}
                        data={assignmentData}
                        usersSubmissionData={selectedAssignmentUserSubmission}
                        currentClass={currentClass}
                        handleClose={() => {
                            onClose()
                            fetchAllData();
                        }}
                        scale_1_5={userPreference?.gradePref == "scale_1_5"}
                        gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                        showAlert={showAlert}
                    />
                </Suspense>
            ) : null}
        </Drawer>
      </SentryWrap>
    )
}
